import React, { Children } from "react";
import { Flex, Card, Input, Modal, Select, Empty, message, Form } from "antd";
import GoodsCard from './card-proxy';
import GoodsFilter from './goods-filter';
import ShopCategorySelect from "../category/shop-category-select";
import getCurrentShop, { getCurrentShopId } from "../shop/get-current-shop";

export default (props) => {
    const { list:goodsList = [], proxyClick, proxyCancel } = props;
    // const [goodsList, setGoodsList] = React.useState([]);
    const [currentShopId, setCurrentShopId] = React.useState(null);
    const [currentShop, setCurrentShop] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [fromShops, setFromShops] = React.useState([]);
    const [form] = Form.useForm();
    
    React.useEffect(() => {
        const fetchData = async () => {
            const shopId = await getCurrentShopId();
            const shop = await getCurrentShop();
            setCurrentShopId(shopId);
            setCurrentShop(shop);
        };
        
        fetchData();
    }, []);

    const onProxyClick = (goodsInfo) => {
        console.log('goodsInfo', goodsInfo);
        form.resetFields();
        const { goodsId, shopId_shops } = goodsInfo;
        form.setFieldsValue({
            title: currentShop?.title,
            shopId: currentShop?.shopId,
            goodsId,
        });
        setOpen(true);

        const options = shopId_shops.map(item => {
            const serviceArea = item.shop_biz_address?.city || item.shop_biz_address?.province || '未知';
            return {
                value: item.shopId,
                label: `${item.title}-${serviceArea}`,
            }
        });

        setFromShops(options);
        proxyClick?.();
    }

    const onProxyCancel = (goodsInfo) => {
        console.log('goodsInfo', goodsInfo);
        const { goodsId } = goodsInfo;

        Modal.confirm({
            title: '确定取消代理？',
            content: '取消代理后，商品将不再显示在店铺中',
            onOk: () => {
                fetch(`/api/goods/proxy-cancel`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        goodsId,
                        shopId: currentShopId,
                    })
                }).then(response => {
                    return response.json();
                }).then(result => {
                    if(result.success) {
                        message.success('取消代理成功');
                        // setGoodsList(goodsList.filter(item => item.goodsId !== goodsId));
                    }else{
                        message.error(result.data);
                    }
                }).finally(() => {
                    proxyCancel?.();
                });
            }
        });
    }

    const onSubmit = () => {
        form.validateFields().then(async values => {
            console.log('values', values);
            const response = await fetch(`/api/goods/proxy`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            });

            const result = await response.json();

            if(result.success) {
                message.success('代理成功');
                setOpen(false);
                // setGoodsList(goodsList.filter(item => item.goodsId !== values.goodsId));
            }else{
                setOpen(false);
                message.error(result.data);
            }
        }).catch(errorInfo => {
            console.log('Failed:', errorInfo);
        });
    }
    
    return (
        <div>
            <Modal title="一键代理" open={open} 
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={onSubmit}
                okText='确定'
                cancelText='取消'
                destroyOnClose={true}
            >
                <Form form={form} style={{margin: '30px 0 30px 0'}}>
                    <Form.Item hidden={true} name='goodsId'></Form.Item>
                    <Form.Item hidden={true} name='shopId'></Form.Item>
                    <Form.Item label="代理店铺" name='title' help="可在屏幕右上角切换店铺">
                        <Input readOnly disabled />
                    </Form.Item>

                    <Form.Item label="店铺分类" name='cateId' rules={[{ required: true, message: '请选择店铺分类' }]}>
                        <ShopCategorySelect />
                    </Form.Item>

                    <Form.Item label="被代理店铺" name='fromShopId' rules={[{ required: true, message: '请选择被代理店铺' }]}>
                        <Select options={fromShops} />
                    </Form.Item>
                </Form>
            </Modal>
            
            {/* <Flex style={{margin: '0 0 10px 0'}}>
                <Input.Search placeholder="商品名称" />
                <GoodsFilter />
            </Flex> */}
            <Flex justify="start" wrap gap={15} align="center">
                {
                    goodsList.map((item, index) => {
                        return <GoodsCard onProxyClick={onProxyClick} onProxyCancel={onProxyCancel} content={item} key={index} />
                    })
                }
                {goodsList.length === 0 && <Empty style={{width: '100%'}} />}
            </Flex>
        </div>
    )
}